import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Fungicidas Microbiologicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function FungicidasMicrobiologicos(props) {
  useEffect(() => {
    const title = 'fungicidaMicroBio.fungicidaMicroBio';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.FUNGICIDA_MICROBIOLOGICO}
      insumoURL='fungicidas-microbiologicos'
      viewKey='fungicidasMicroBio'
      deleteMessageSucess={formatMessage(
        'fungicidaMicroBio.fungicidaMicroBioRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('fungicidaMicroBio.falhaAoExcluirFungicidaMicroBio')}
      mensagemDelete={formatMessage('fungicidaMicroBio.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'fungicidasMicroBio';
  })[0].content
});

export default connect(mapStateToProps)(FungicidasMicrobiologicos);
